"use client"

import { ReactNode, useEffect, useState, PropsWithChildren } from "react"
import { useAuth } from "react-oidc-context"
import { Button } from "@/components/ui/button"
import { useBrandConfig } from "@/hooks/useBrandConfig"

function AutoSigninContent({ children }: PropsWithChildren) {
  const auth = useAuth()
  const brand = useBrandConfig()

  if (auth.isLoading) {
    return <div className="flex items-center justify-center min-h-screen text-xl">読み込み中…</div>
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-6">
        {brand.welcomeLogo ? (
          <img
            src={`/${brand.welcomeLogo}`}
            alt={brand.appTitle}
            className="w-64 max-w-[70vw]"
            onError={(e) => {
              e.currentTarget.style.display = "none"
            }}
          />
        ) : null}
        <p className="text-2xl font-semibold">{brand.appTitle} へようこそ</p>
        <p className="text-muted-foreground">続けるにはサインインしてください</p>
        <Button onClick={() => auth.signinRedirect()}>サインイン</Button>
      </div>
    )
  }

  return <>{children}</>
}

export function AutoSignin({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return <AutoSigninContent>{children}</AutoSigninContent>
}
